(function() {
  // Add custom code below this line

    $('.announcement-bar-container-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 2000
  });

  setInterval(function time(){
    var d = new Date();
    var d1 = new Date();
    d.setHours(d1.getHours() + 12)
    var hours = 24 - d.getHours();
    var min = 60 - d.getMinutes();
    if((min + '').length == 1){
      min = '0' + min;
    }
    var sec = 60 - d.getSeconds();
    if((sec + '').length == 1){
          sec = '0' + sec;
    }
    $('.timer').html(hours+' timer '+min+' min '+sec+ ' sek')
    if(hours >= 12){
      $(".today-tomorrow-i").html("imorgen.")
    }else{
      $(".today-tomorrow-i").html("idag.")
    }
  }, 1000);
  
  var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  var currentDateNew = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  var day = currentDateNew.getDate()
  let dayN="th";
  switch (day) {
    case 1:
      dayN = "st";
      break;
    case 2:
      dayN = "nd";
      break;
    case 3:
      dayN = "rd";
      break;
    default:
      dayN = "th";
  }
  var month = currentDate.getMonth() + 1
  var year = currentDate.getFullYear()
  var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  $(".date-product").html(days[currentDateNew.getDay()] + " " + day + dayN +" "  + monthNames[currentDateNew.getMonth()])

  $(".read-more-btn").click(function () {
    $(".product-block--tab-click button").click()
  })

    
    theme.ShippingBar = (function() {
      
      var bar = document.querySelector('.shipping-bar');
     
      if(bar)
      {
      var promote_txt = bar.dataset.promote;
      var unlocked_txt = bar.dataset.unlocked;
      var treshold = bar.dataset.treshold;
      }
      
      function update()
      {
        if(bar)
        {
        $.getJSON('/cart.js').then(
        
          function(cart) {
            
            var value_left = treshold - cart.total_price;
            var value_left_money = theme.Currency.formatMoney(value_left,theme.moneyFormat);
            
            if(value_left <= 0){
              bar.innerHTML =  '<p class="shipping-bar__message">' + unlocked_txt + '</p>';
              bar.classList.add("is-success-shipping");
              document.getElementById("shipping-slider-bar").style.width = 1*100 + '%';
            }
            else{
              bar.innerHTML = '<p class="shipping-bar__message">' + promote_txt.replace('[value]',value_left_money) + '</p>';
              bar.classList.remove("is-success-shipping");
              document.getElementById("shipping-slider-bar").style.width = (cart.total_price/treshold)*100 + '%';
            }
            
          }
          
        );
        }
      }
      return { update:update }
    }) ();








$(".cart-click-close").click(()=>{
  $(".cart-open .site-header__drawers-container").click()
})

function myFunctionFooterMenu(x) {
  if (x.matches) { // If media query matches
    $(".footer__block .footer__title:first-child").click(function(){
      let $this = $(this)
      $(this).toggleClass("activated")
      $(this).next().slideToggle("fast")
      $(this).next().next().slideToggle("fast")
      $(this).next().next().next().slideToggle("fast")
    })
  }
}
var x = window.matchMedia("(max-width: 767.98px)")
myFunctionFooterMenu(x) // Call listener function at run time
x.addListener(myFunctionFooterMenu) // Attach listener function on state changes
$(".chat-btn-bottom").click(()=>{
  $(".chat-toggle--text-button").click()
})
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



















